import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CindiService {
  pontuation: number = 0;
  private finalQuestionsPontuation: number = 0;
  heigth!: number;
  weigth!: number;
  resultadoIMC!: number;
  faixaIMC!: string;
  grauDeRiscoIMC!: string;

  constructor() {}

  addPontuation(points: number) {
    this.pontuation += points;
  }

  calculateIMCscore() {
    const heightExp = this.heigth ** 2;
    this.resultadoIMC = (this.weigth / heightExp);

    if (this.resultadoIMC < 18.5) {
      this.faixaIMC = "abaixo do peso";
      this.grauDeRiscoIMC = "baixo";
    } else if (this.resultadoIMC >= 18.5 && this.resultadoIMC < 25) {
      this.faixaIMC = "dentro do peso (eutrófico)";
      this.grauDeRiscoIMC = "médio";
    } else if (this.resultadoIMC >= 25 && this.resultadoIMC < 30) {
      this.faixaIMC = "na faixa de sobrepeso";
      this.grauDeRiscoIMC = "pouco elevado";
    } else if (this.resultadoIMC >= 30 && this.resultadoIMC < 35) {
      this.faixaIMC = "na faixa de obesidade grau I";
      this.grauDeRiscoIMC = "elevado";
    } else if (this.resultadoIMC >= 35 && this.resultadoIMC < 40) {
      this.faixaIMC = "na faixa de obesidade grau II";
      this.grauDeRiscoIMC = "muito elevado";
    } else if (this.resultadoIMC >= 40) {
      this.faixaIMC = "na faixa de obesidade grau III";
      this.grauDeRiscoIMC = "muitíssimo elevado";
    }
  }
}
